import { useEffect, useState } from "react"
import Form from 'react-bootstrap/Form'

import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"

import * as Basic from "../../../Modules/BasicFields"

const auctionHouseVariables = [
    {name:'Output', key:'output', type:'W'},
]

export default function AuctionHouse( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected
    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)
    const [ minValue, setMinValue ] = useState(null)
    const [ hashtagRate, setHashtagRate ] = useState(null)

    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)

    const requiredData = [
        hashtag, 
        minValue,
        hashtagRate,
        font,
        variables
    ]

    const cfgName = "kingmaker_auction_house_cfg"


    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setHashtag( cfg.hashtag || "" )  
        setMinValue( (cfg.min_value != null) ? cfg.min_value : 0 )
        setHashtagRate( cfg.hashtag_rate || "one_per_user" )

        setFont( cfg.font || {})
        setVariables( cfg.variables || {})
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font 
        data.variables = variables

        data.hashtag = hashtag
        data.min_value = minValue
        data.hashtag_rate = hashtagRate 
       
        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ hashtag, minValue, hashtagRate, font, variables ])

    if( requiredData.includes(null) )
    {
        return (<></>)
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag}/>
                <Basic.PositiveIntegerInput name="Min value" value={minValue} setValue={setMinValue}/>
                <Basic.SelectInput name="Frequency per viewer" value={hashtagRate} setValue={setHashtagRate} 
                                   options={[
                                        { label: "One time only", value: "one_per_user" },
                                        { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                        { label: "Once every minute", value: "one_every_minute" },
                                        { label: "Unlimited", value: "unlimited" },
                                    ]}
                /> 
            </SettingsGroup>

            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={auctionHouseVariables}
                            reset={reset}
            />
        </>
    )
}

